import * as React from 'react';
import { CategoryWell } from 'owa-categories';
import type CategoryType from 'owa-service/lib/contract/CategoryType';

let styles = require('./CategoriesContainer.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CategoryContainerProps {
    categories: string[];
    categoriesContainer?: string;
    categoryList: CategoryType[];
}

const CategoriesContainer = (props: CategoryContainerProps) => {
    return (
        <CategoryWell
            categories={props.categories}
            categoryWellContainerClass={classNames(
                props.categoriesContainer,
                styles.categoriesBaseContainer
            )}
            categoryList={props.categoryList}
        />
    );
};

export default CategoriesContainer;
